class ProductLinks extends HTMLElement {
    constructor() {
        super();

        this.productTitle = this.querySelector(".product-var-title")
        this.productLinks = this.querySelectorAll(".variant-option-link")

        this.productLinks.forEach((link) => {
            link.addEventListener("mouseenter", this.onLinkHover.bind(this));
            link.addEventListener("mouseleave", this.onMouseLeave.bind(this));
        })
    }

  
    onLinkHover(event) {
        event.preventDefault();
        this.productTitle.innerHTML = event.currentTarget.dataset.title
    }

    onMouseLeave() {
        this.productTitle.innerHTML = this.productTitle.dataset.default
    }

}
  
customElements.define('product-links', ProductLinks);